import { render } from "./ComingSoon.vue.js?vue&type=template&id=cbb32a2c&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoon.vue?vue&type=template&id=cbb32a2c&scoped=true"
import script from "./ComingSoon.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue.scss?vue&type=style&index=0&id=cbb32a2c&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoon.vue?vue&type=style&index=0&id=cbb32a2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb32a2c"],['__file',"src/Web/scripts/components/ComingSoon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbb32a2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbb32a2c', __exports__)) {
    api.reload('cbb32a2c', __exports__)
  }
  
  module.hot.accept("./ComingSoon.vue.js?vue&type=template&id=cbb32a2c&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoon.vue?vue&type=template&id=cbb32a2c&scoped=true", () => {
    api.rerender('cbb32a2c', render)
  })

}


export default __exports__